import "core-js/modules/es6.string.link";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
export default {
  props: ['item'],
  methods: {
    clickHandler: function clickHandler() {
      window.location.href = this.item.link;
    }
  }
};